import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSession from './session.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SessionEffects } from './session.effects';
import { SessionService } from './session.service';
import { LoggedInGuard } from './logged-in.guard';
import { SessionApiService } from './session.api.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TenantStoreModule } from '../tenant-store/tenant-store.module';
import { AuthHttpInterceptor } from './auth-http.interceptor.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromSession.sessionFeatureKey, fromSession.reducer),
    EffectsModule.forFeature([SessionEffects]),
    TenantStoreModule,
  ],
  providers: [
    SessionService,
    SessionApiService,
    LoggedInGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SessionStoreModule {}
